module.exports = __webpack_public_path__ + "static/media/flights-icon.2ac7ed08.PNG";